module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.render) ? _c('div', {
    staticClass: "main-page-box"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-start d-split"
  }, [_c('payment-form', {
    ref: "paymentForm",
    staticClass: "payment-form-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box-wrap"
  }, [_c('div', {
    staticClass: "price-box page-box"
  }, [_c('div', {
    staticClass: "price-label"
  }, [_vm._v("Best Price From")]), _vm._v(" "), _c('div', {
    staticClass: "price-value"
  }, [_vm._v("\n           $" + _vm._s(_vm.discount(_vm.view.Price, 35).discounted) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "lr-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.view.Cancellation_available) ? _c('div', {
    staticClass: "cxl-box page-box"
  }, [_c('div', {
    staticClass: "page-label"
  }, [_vm._v("Cancellation Policy")]), _vm._v(" "), _c('div', {
    staticClass: "cxl-desc"
  }, [_vm._v(_vm._s(_vm.view.Cancellation_Policy))])]) : _vm._e()])], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34d3a6df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d3a6df","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DThingsList/review.vue
// module id = 2067
// module chunks = 0